import type { ReactElement } from "react";

import { SelectInput } from "@/components/admin/select-input";

import {
  VENDORED_LANGUAGES,
  formatLanguage,
} from "../contact-language/languages";

/**
 * Every language an Echo can be made in, English first ("русский · Russian").
 * The vendored echo-language registry, not the bot's live list: the filter is
 * a projection query, not an edit (same rule as the contact list filter).
 */
export const ECHO_LANGUAGE_CHOICES: readonly { id: string; name: string }[] =
  VENDORED_LANGUAGES.map((language) => ({
    id: language.code,
    name: formatLanguage(language),
  }));

/**
 * Content-language filter for the Echo and session lists (RU-500). The
 * dashboard API answers `?content_language=` since LANG-401: codes compare
 * case-insensitively and "en" also matches every Echo with no stored language
 * (an English Echo made before the feature, or one that stayed English).
 */
export const echoLanguageFilter = (): ReactElement => (
  <SelectInput
    source="content_language"
    label="Language"
    emptyText="Any language"
    choices={[...ECHO_LANGUAGE_CHOICES]}
    optionText="name"
    optionValue="id"
  />
);
